import React from 'react';

/** A one-line message in an onboarding tab's panel: loading, an error, or an empty tab. */
const PanelMessage = ({ children }) => <p className="py-6 text-center text-[13px] text-slate-500">{children}</p>;

export default PanelMessage;
